import React from "react";
import { StateDispatchProps } from "../state-dispatch.props";
import { QqGroupTypeEnum } from "../../model/qq-group-type.enum";
import { QqControlsGroupOpenControl } from "../../controls/qq-controls-group-open-control";
import { QqControlsGroupAdditionalControl } from "../../controls/qq-controls-group-additional-control";
import { Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { resetAction } from "../../message-interop/control-actions/reset.action";

export type QuizPaneComponentProps = StateDispatchProps;

export const QuizPaneComponent: React.FunctionComponent<QuizPaneComponentProps> =
  ({ dispatch, state }) => {
    const groups = state.qqBundle.groups.map((group, index) => {
      const element =
        group.type === QqGroupTypeEnum.open ? (
          <React.Fragment>
            <QqControlsGroupOpenControl
              key={index}
              dispatch={dispatch}
              group={group}
              state={state}
            />
          </React.Fragment>
        ) : (
          <QqControlsGroupAdditionalControl
            key={index}
            dispatch={dispatch}
            group={group}
            state={state}
          />
        );

      return element;
    });

    return (
      <React.Fragment>
        {groups}
        <Button
          onClick={() => dispatch(resetAction())}
          startIcon={<RefreshIcon fontSize="small" />}
          sx={{
            paddingLeft: "14px",
            paddingRight: "14px",
            marginTop: "14px",
            backgroundColor: "#E8F0FE",
            color: "#003ECD",
            textTransform: "none",
            fontFamily: "Roboto-Regular",
            "&:hover": {
              backgroundColor: "#E8F0FE",
            },
          }}
        >
          Reset
        </Button>
      </React.Fragment>
    );
  };
